import { useEffect, useState } from 'react';
import { DeviceInfo, getDeviceInfo, shouldShowDownloadPrompt, dismissDownloadPrompt } from '../utils/deviceDetection';

export function useMobileAppPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo | null>(null);

  useEffect(() => {
    // Get device information
    const info = getDeviceInfo();
    setDeviceInfo(info);

    // Determine if we should show the prompt
    const shouldShow = shouldShowDownloadPrompt();
    
    console.log('[Mobile App Prompt]', {
      deviceType: info.type,
      environment: info.environment,
      shouldShow,
      userAgent: info.userAgent
    });

    if (shouldShow) {
      // Show prompt after a short delay for better UX
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    setShowPrompt(false);
    dismissDownloadPrompt();
  };

  return {
    showPrompt,
    deviceInfo,
    handleDismiss,
  };
}

